import { Styles } from 'react-jss'

export const sheet: Styles = {
  title: {},
  count: {},
  text: {},
  root: {
    width: 343,
    minHeight: 110,
    position: 'relative',
    background: '#FAFAFA',
    border: '1px solid #286EFA',
    overflow: 'hidden',
    boxSizing: 'border-box',
    padding: '10px 12px',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: 12,
    lineHeight: '16px',
    letterSpacing: '0.01em',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'center',
    color: '#565656',
    '& $text a': {
      whiteSpace: 'inherit',
      wordBreak: 'break-all'
    },
    '&:after': {
      content: ` url("${require('components/svg/particlesNotification.svg')}")`,
      position: 'absolute',
      top: 0,
      right: 0
    },
    '& > p': {
      margin: 0
    }
  },
  unread: {
    background: '#FEFAF1'
  }
}
